import React from "react";
import { GrUserSettings } from "react-icons/gr";
import { BsChevronDoubleLeft } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { BiCategoryAlt } from "react-icons/bi";
import { useMainContext } from "../../Context";

const Subject = ({ title, image, category_id }) => {
  const { dispatch } = useMainContext();
  const navigate = useNavigate();
  return (
    <div className="subject">
      <div className="information">
        <div>{image?.url ? <img src={image?.url} /> : <BiCategoryAlt />}</div>
        <div className="mr-7">
          <p className="title  fs-14">{title}</p>
          <p className="description  fs-10">آگهی های {title}</p>
        </div>
      </div>
      <button
        to={`/list?category_id=${category_id}`}
        className="icon-title-wrapper"
        onClick={() => {
          dispatch("category", { id: category_id, title, image });
          navigate("/list");
        }}
      >
        <p>مشاهده همه</p>
        <BsChevronDoubleLeft />
      </button>
    </div>
  );
};

export default Subject;
